import React from 'react';
import styles from './TariffsBottomText.module.scss';

const TariffsBottomText: React.FC = () => {
  return (
    <div className={styles.container}>
      <p>
        Тарифы облагаются НДС по ставке, предусмотренной действующим
        законодательством Российской Федерации.
      </p>
      <p>
        * «Оплата с победителя» позволяет участнику подать заявку на закупку при
        наличии требуемой суммы на лицевом счёте. Сумма будет заблокирована в
        момент подачи заявки. После публикации итогового протокола происходит
        списание с победителя заблокированных средств в размере тарифа.
        Участникам, не победившим в закупке, сумма разблокируется.
      </p>
    </div>
  );
};

export default TariffsBottomText;
